let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("hPzOn"), load("h2MrD"), load("bYT2S"), load("cM9em"), load("fr9NE"), load("4a74D")]).then(() => parcelRequire('fEx2J'));